import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_get_order_lines_for_shipmentService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shipment_id?: number, order_id?: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, LotId?: number, MaterialId?: number, Notes?: string, PackagedAmount?: number, PackagedId?: number, StatusId?: number, VendorLotId?: number, Status?: { Id?: number, Name?: string }, Material?: { Id?: number, Description?: string, Name?: string }, MaterialPackagingLookup?: { PackagingId?: number, Packaging?: { Id?: number, Name?: string } }, Lot?: { Id?: number, LookupCode?: string }, VendorLot?: { LookupCode?: string } }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { shipment_id?: number, order_id?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, LotId?: number, MaterialId?: number, Notes?: string, PackagedAmount?: number, PackagedId?: number, StatusId?: number, VendorLotId?: number, Status?: { Id?: number, Name?: string }, Material?: { Id?: number, Description?: string, Name?: string }, MaterialPackagingLookup?: { PackagingId?: number, Packaging?: { Id?: number, Name?: string } }, Lot?: { Id?: number, LookupCode?: string }, VendorLot?: { LookupCode?: string } }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { shipment_id?: number, order_id?: number, $keys: { OrderId?: number, LineNumber?: number }[] }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, LotId?: number, MaterialId?: number, Notes?: string, PackagedAmount?: number, PackagedId?: number, StatusId?: number, VendorLotId?: number, Status?: { Id?: number, Name?: string }, Material?: { Id?: number, Description?: string, Name?: string }, MaterialPackagingLookup?: { PackagingId?: number, Packaging?: { Id?: number, Name?: string } }, Lot?: { Id?: number, LookupCode?: string }, VendorLot?: { LookupCode?: string } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shipment_id?: number, order_id?: number    }) {
      return false;
    }
}
